export default "__VITE_ASSET__CAimT$ch__"